import FrenchPage from '../components/lifecycle/FrenchPage';
import OutsideHeadFR from '../components/outside/OutsideHeadFR';
import OutsideHouse from './OutsideHouse';

export default function OutsideHouseFR() {
  return (
    <>
      <FrenchPage />
      <OutsideHeadFR />
      <OutsideHouse />
    </>
  );
}